class DataUtil {
  fixBinary (bin) {
      var length = bin.length;
      var buf = new ArrayBuffer(length);
      var arr = new Uint8Array(buf);
      for (var i = 0; i < length; i++) {
        arr[i] = bin.charCodeAt(i);
      }
      return buf;
  }

  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  getErrorDescription(errorCode) {
    if (errorCode === 2){
      return "TK sai, trả về TK";
    }
    if (errorCode === 3){
      return "Sai size";
    }
    if (errorCode === 4){
      return "Sai kỹ thuật";
    }
    if (errorCode === 5){
      return "Cắt khắc sai";
    }
    if (errorCode === 6){
      return "Bạc dộp";
    }
    if (errorCode === 7){
      return "Quay kim không đủ, không đều";
    }
    if (errorCode === 8){
      return "Xước, mẻ, lỗ bề mặt";
    }
    if (errorCode === 9){
      return "Lỗi Xi";
    }
    if (errorCode === 11){
      return "Lỗi mối hàn";
    }
    if (errorCode === 12){
      return "Lỗi trầy khi đóng gói";
    }
    if (errorCode === 10){
      return "Lỗi khác";
    }

    if (errorCode === 13){
      return "Lỗi khác (Thợ)";
    }

    if (errorCode === 14){
      return "Lỗi Xi đánh lại";
    }
    return errorCode;   
  }
}

export default new DataUtil();

